import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import TimerProgressCircle from './TimerComponet';
import { formatCountdown } from '../utils/usePomodoro';

export default function PomodoroClock({ timer, remainingMs, expanded = false }) {
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down('sm'));
  const size = expanded ? (small ? 270 : 400) : (small ? 218 : 250);
  const long = remainingMs >= 100 * 60000;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 1, '& .MuiCircularProgress-root': { color: 'primary.main' } }}>
      <TimerProgressCircle size={size} thickness={2} value={Math.max(0, Math.min(100, remainingMs / timer.durationMs * 100))}
        label={(
          <Box role="timer" aria-label={`${timer.phase === 'focus' ? 'Focus' : 'Break'} time remaining`} aria-live="off" sx={{
            color: 'primary.main', fontVariantNumeric: 'tabular-nums',
            fontSize: expanded ? { xs: long ? '2rem' : '2.6rem', sm: long ? '3rem' : '4rem' } : long ? '1.5rem' : '2.1rem',
            textShadow: `0 0 22px ${alpha(theme.palette.primary.main, 0.3)}`,
          }}>{formatCountdown(remainingMs)}</Box>
        )} />
    </Box>
  );
}
